import React from 'react';
import PropTypes from 'prop-types';

import step1 from '../images/test-step-1.svg';
import step2 from '../images/test-step-2.svg';
import step3 from '../images/test-step-3.svg';
import step4 from '../images/test-step-4.svg';
import step5 from '../images/test-step-5.svg';
import step6 from '../images/test-step-6.svg';
import step7 from '../images/test-step-7.svg';
import step8 from '../images/test-step-8.svg';
import step9 from '../images/test-step-9.svg';

const stepImages = {
  step1,
  step2,
  step3,
  step4,
  step5,
  step6,
  step7,
  step8,
  step9,
  step10: step9
};

const ProgressBar = ({ testId }) => (
  <div className="container">
    <div className="row margin-top-xl">
      <div className="col-xs-10 col-xs-offset-1 col-sm-6 col-sm-offset-3 text-center">
        <div className="dialog dialog-default full-width horizontal-center">
          {
            (testId !== 'wait') ?
              <img src={stepImages[`step${testId}`]} alt="progress bar" />
              :
              ''
          }
        </div>
      </div>
    </div>
  </div>
);

ProgressBar.propTypes = {
  testId: PropTypes.string.isRequired
};

export default ProgressBar;



// WEBPACK FOOTER //
// ./app/components/ProgressBar.js